import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

export const DEFAULT_CATEGORIES = {
  build: {
    title: "Build Your Box",
    tagline: "One bottle size",
    desc: "Buy one size in bulk. Pick your size, choose how many bottles, then click each bottle tile to fill it with any flavour, base and strength. The more you add, the lower the price per bottle.",
  },
  deals: {
    title: "Multipack Deals",
    tagline: "Mixed sizes · multipack saving",
    desc: "Choose 1–5L total volume, pick a mixed-size multipack, then fill every bottle with its flavour, base and strength.",
  },
  guest: {
    title: "Premium Brands",
    tagline: "Limited premium brands",
    desc: "Special premium-brand flavours in a fixed size — single flavour, no add-ons. Just choose your quantity and add straight to your cart.",
  },
  economy: {
    title: "Economy Flavours",
    tagline: "Budget range · two flavours",
    desc: "Our low-cost range: Strawberry Vanilla or Unflavoured Clear, one base, with ×2 and ×3 strength options. Pick a size, choose how many, and fill your box.",
  },
};

export const mergeCategories = (saved) => {
  const out = {};
  Object.keys(DEFAULT_CATEGORIES).forEach((k) => {
    const s = saved?.[k] || {};
    out[k] = {
      title: s.title?.trim() || DEFAULT_CATEGORIES[k].title,
      tagline: s.tagline?.trim() || DEFAULT_CATEGORIES[k].tagline,
      desc: s.desc?.trim() || DEFAULT_CATEGORIES[k].desc,
    };
  });
  return out;
};

const Ctx = createContext({ content: {}, categories: DEFAULT_CATEGORIES, refresh: () => {} });

export const SiteContentProvider = ({ children }) => {
  const [content, setContent] = useState({});
  const refresh = useCallback(() => api.get("/content").then((r) => setContent(r.data || {})).catch(() => {}), []);
  useEffect(() => { refresh(); }, [refresh]);
  return <Ctx.Provider value={{ content, categories: mergeCategories(content.categories), refresh }}>{children}</Ctx.Provider>;
};

export const useSiteContent = () => useContext(Ctx);
export const useCategories = () => useContext(Ctx).categories;
